export default __webpack_public_path__ + "static/media/icn-arrow-back.ba469cfd.svg";